<template>
  <div class="page-container">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { eventBus } from "@/services/EventBus"

export default defineComponent({
  name: "PageView",
  components: {},
  props: {
    noSubTitleExpected: {
      type: Boolean,
      default: false,
    },
    mainTitle: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    subTitleIcon: {
      type: String,
      default: "",
    },
    subTitleIsEditable: {
      type: Boolean,
      default: false,
    },
    displaySubTitleInGreen: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    "main-title-changed",
    "sub-title-changed",
    "sub-title-icon-changed",
    "sub-title-is-editable-changed",
    "display-sub-title-in-green-changed",
  ],
  watch: {
    mainTitle: {
      handler(): void {
        this.onMainTitleChanged()
      },
      immediate: true,
    },
    subTitle: {
      handler(): void {
        this.onSubTitleChanged()
      },
      immediate: true,
    },
    subTitleIcon: {
      handler(): void {
        this.onSubTitleIconChanged()
      },
      immediate: true,
    },
    subTitleIsEditable: {
      handler(): void {
        this.onSubTitleIsEditableChanged()
      },
      immediate: true,
    },
    displaySubTitleInGreen: {
      handler(): void {
        this.onDisplaySubTitleInGreenChanged()
      },
      immediate: true,
    },
  },
  mounted(): void {
    this.onMainTitleChanged()
    this.onSubTitleChanged()
    this.onSubTitleIsEditableChanged()
    this.onDisplaySubTitleInGreenChanged()
  },
  methods: {
    onMainTitleChanged(): void {
      eventBus.emit("main-title-changed", this.mainTitle)
    },

    onSubTitleChanged(): void {
      // If subtitle is empty but we are expecting a subitle, do not emit event yet, wait for subtitle
      if (this.subTitle || this.noSubTitleExpected) {
        eventBus.emit("sub-title-changed", this.subTitle)
      }
    },

    onSubTitleIconChanged(): void {
      eventBus.emit("sub-title-icon-changed", this.subTitleIcon)
    },

    onSubTitleIsEditableChanged(): void {
      eventBus.emit("sub-title-is-editable-changed", this.subTitleIsEditable)
    },

    onDisplaySubTitleInGreenChanged(): void {
      eventBus.emit("display-sub-title-in-green-changed", this.displaySubTitleInGreen)
    },
  },
})
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.page-container {
  padding-top: $HeaderInfo-height;
  padding-left: $page-container-padding;
  padding-right: $page-container-padding;
  background-color: $modal-background-color;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
}
</style>
